<template>
  <v-dialog :value="value"
            persistent
            :width="modalWidth"
            content-class="modal modal-round modal-overflow"
            @input="setFocus">

    <div class="close"
         @click="hideModal">&times;</div>

    <v-card>
      <h1>{{$t('message.spots.message.device')}}</h1>

      <div class="body">
        <app-stepper-section :style="settingsStyle"
                             class="body-column">

          <app-stepper-section class="body-column-section"
                               :label="$t('message.generics.message.generalData')">
            <v-text-field ref="firstInput"
                          :label="$t('message.spots.message.deviceName')"
                          :name="$t('message.spots.message.deviceName')"
                          v-validate="'required'"
                          :error-messages="errors.collect($t('message.spots.message.deviceName'))"
                          v-model="form.name"></v-text-field>
          </app-stepper-section>

          <app-stepper-section class="body-column-section alinhar-items"
                               :label="$t('message.spots.message.linkSpot')">
            <app-select v-model="form.local"
                        :data-title="$t('message.spots.message.select')"
                        :data-search="false"
                        :data-items="localOptions"
                        :clearable="false" />
          </app-stepper-section>

          <app-stepper-section v-if="canChangeApsCount"
                               class="body-column-section"
                               :label="$t('message.settings.message.devicesQuantity')">
            <v-text-field class="access-point-input"
                          :name="$t('message.settings.message.devicesQuantity')"
                          v-validate="'required|min_value:1'"
                          :error-messages="errors.collect($t('message.settings.message.devicesQuantity'))"
                          type="number"
                          v-model="form.accessPointCount"></v-text-field>
          </app-stepper-section>
        </app-stepper-section>

        <app-stepper-section class="body-column">
          <app-stepper-section class="body-column-section alinhar-items"
                               :label="$t('message.spots.message.deviceType')">
            <v-expansion-panel v-model="isOpened"
                               expand
                               class="select-expansion-panel"
                               :class="{'expansion-opened': isExpansionPanelOpened}">
              <v-expansion-panel-content class="select-expansion-panel-content"
                                         :class="{'select-expansion-panel-content-special': isSpecialLogoHeader}">
                <template v-slot:header>
                  <div class="select-expansion-panel-content-header">
                    <i v-if="!selectedDevice"
                       class="mdi mdi-router-wireless pointer"></i>
                    <img v-else
                         :src="`images/devices-logo/${logo}.svg`"
                         :alt="`${logo}-logo`"
                         class="select-expansion-panel-content-header-logo"
                         :class="{'special-select-expansion-panel-content-header-logo': isSpecialLogoHeader}">
                    <p class="select-expansion-panel-content-header-title">{{ deviceSelectionTitle }}</p>
                  </div>
                </template>

                <div class="select-expansion-panel-content-body">
                  <ul class="select-expansion-panel-content-body-list">
                    <template v-for="(item, index) in formattedDeviceTypes">
                      <div :key="index"
                           class="flex-container">
                        <img :src="`images/devices-logo/${returnCorrectLogo(null, item.brand)}.svg`"
                             class="logo"
                             :class="{'special-logo': isSpecialLogo(item.brand)}">
                        <li v-if="item.types.length === 1 && !isSpecialCase(item.brand)"
                            class="select-expansion-panel-content-body-list-item"
                            @click="setSelectedDevice($event, item.brand)">{{ formatName(null, item.brand) }}</li>
                        <ul v-else
                            class="select-expansion-panel-content-body-list sublist">{{ formatName(null, item.brand) }}
                          <li v-for="(subitem, index) in item.types"
                              :key="index"
                              class="select-expansion-panel-content-body-list-item subitem"
                              @click="setSelectedDevice($event, subitem)">
                            - {{ formatName(item.brand, subitem) }}
                          </li>
                        </ul>
                      </div>
                    </template>
                  </ul>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </app-stepper-section>
          <app-stepper-section :style="settingsStyle"
                               class="body-column-section "
                               :label="$t('message.generics.message.settings')">
            <v-text-field v-validate="isKeyGenerate? '' : 'required'"
                          :label="$t('message.spots.message.deviceKey')"
                          :name="$t('message.spots.message.deviceKey')"
                          :disabled="isKeyGenerate"
                          :error-messages="errors.collect($t('message.spots.message.deviceKey'))"
                          v-model="form.key">
            </v-text-field>
          </app-stepper-section>
        </app-stepper-section>
      </div>

      <div :style="settingsStyle"
           class="card-footer">
        <button class="btn btn-primary btn-round"
                @click="validate()">
          {{$t('message.generics.message.save')}}
        </button>
      </div>
    </v-card>

    <confirmation-modal :value="showingAditionalFeeModal"
                        confirm-label="Confirmar"
                        :max-width="350"
                        @confirm="continueModalCreation"
                        @cancel="hideAditionalFeeModal">
      <span slot="heading">
        {{$t('message.spots.message.continueDeviceCreationQuestion')}}
      </span>
      <div class="aditional-fee-text-wrapper">
        <span>
          {{$t('message.spots.message.continueDeviceCreationExplanation')}}
        </span>
        <v-checkbox label="Não mostrar novamente"
                    hide-details
                    v-model="doNotShowAditionalFeeModalAgain" />
      </div>
    </confirmation-modal>
  </v-dialog>
</template>

<script>
import AppSelect from "@components/Select";
import AppStepperSection from "@components/StepperSection";
import EventBus from "@packages/event-bus/index";
import ConfirmationModal from "../../components/ConfirmationModal.vue";

export default {
  components: {
    AppStepperSection,
    AppSelect,
    ConfirmationModal,
  },

  data() {
    return {
      show: false,
      form: {},
      localOptions: [],
      // deviceTypes: [],
      isEdit: false,
      drag: false,
      showingAditionalFeeModal: false,
      shouldContinueDeviceCreation: false,
      doNotShowAditionalFeeModalAgain: false,
      isOpened: [false],
      selectedDevice: undefined,
      formattedDeviceTypes: [],
      logo: undefined,
    };
  },

  props: {
    node: {
      type: Object,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
      permissions() {
          return this.$store.state.users.user.permissions;
      },
      user() {
          return this.$store.state.users.user;
      },
      allAccessPointGenerateWiFeedKey() {
          return !!this.user.permissions.find((x) => x === "WIFEED_KEY_INTERNAL_GENERATE");
      },
    canChangeApsCount() {
      return (
        this.selectedDevice === "MIKROTIK" ||
        this.selectedDevice === "Mikrotik" ||
        this.selectedDevice === "FORTIGATE_FIREWALL" ||
        this.selectedDevice === "Fortigate Fortinet (Firewall)" ||
        this.selectedDevice === "TPLINK_GATEWAY_STANDALONE" ||
        this.selectedDevice === "Gateway Standalone TPlink" ||
        this.allAccessPointGenerateWiFeedKey
      );
    },
    isKeyGenerate() {
      return (
        this.selectedDevice === "MIKROTIK" ||
        this.selectedDevice === "Mikrotik" ||
        this.selectedDevice === "FORTIGATE_FIREWALL" ||
        this.selectedDevice === "Fortigate Fortinet (Firewall)" ||
        this.selectedDevice === "TPLINK_GATEWAY_STANDALONE" ||
        this.selectedDevice === "Gateway Standalone TPlink" ||
        this.allAccessPointGenerateWiFeedKey
      );
    },
    totalDevicesNumber() {
      return this.$store.state.devices.count;
    },
    isExpansionPanelOpened() {
      return this.isOpened.includes(true);
    },
    settingsStyle() {
      return {
        display: this.isExpansionPanelOpened ? "none" : "block",
      };
    },
    deviceSelectionTitle() {
      return this.selectedDevice
        ? this.devicesTypes[this.form.deviceType]
        : "Selecione o tipo de aparelho";
    },
    modalWidth() {
      return this.isExpansionPanelOpened ? "600" : "1000";
    },
    type() {
      return this.form.deviceType;
    },
    isSpecialLogoHeader() {
      return this.form.deviceType
        ? this.form.deviceType.includes("CISCO") ||
            this.form.deviceType === "INTELBRAS"
        : false;
    },
    devicesTypes() {
      return this.$store.state.devices.devicesTypes;
    },
  },

  watch: {
    deviceTypes(newVal, oldVal) {
      if (newVal && oldVal) {
        this.setDeviceTypesFormatted();
      }
    },
  },

  methods: {
    dragToTrue() {
      this.drag = true;
    },
    dragToFalse() {
      this.drag = false;
    },
    closeModal(event) {
      if (event.target.className.includes("v-overlay") && !this.drag) {
        this.hideModal();
      }
    },
    emitInput(val) {
      this.$emit("input", val);
    },
    hideModal() {
      this.emitInput(false);
    },
    setFocus() {
      if (this.value) {
        this.$nextTick(() => {
          this.$refs.firstInput.focus();
        });
      }
    },
    async reset() {
      if (this.node.tipo === "LOCAL") {
        this.localOptions = [
          {
            id: this.node.id,
            label: this.node.nome,
          },
        ];

        this.form = {
          local: this.node.id,
          deviceType: undefined,
        };

        this.selectedDevice = undefined;
      } else if (this.node.tipo === "GRUPO_PONTO_ACESSO") {
        const accessPointGroup = await this.$api.accessPointGroup.get({
          id: this.node.id,
        });

        this.localOptions = [
          {
            id: accessPointGroup.localId,
            label: accessPointGroup.localNome,
          },
        ];

        this.form = {
          grupoId: accessPointGroup.id,
          local: accessPointGroup.localId,
        };
      }

      await this.setDeviceTypesFormatted();
    },
    async validate() {
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        this.save();
      }
    },
    async save() {
      try {
        if (!this.isEdit) {
          if (
            this.totalDevicesNumber > 4 &&
            !this.shouldContinueDeviceCreation
          ) {
            const { showPaymentInfo } =
              await this.$api.core.account.getAccountEstablishmentConfig();
            if (showPaymentInfo) {
              this.showingAditionalFeeModal = true;
              return;
            }
          }

          const newDevice = await this.$api.devices.userCreate({
            nome: this.form.name,
            tipo: this.form.deviceType,
            localId: this.form.local,
            grupoId: this.form.grupoId,
            chave: this.form.key,
            accessPointCount: this.form.accessPointCount,
          });

          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t("message.successMessages.message.deviceCreated"),
            timeout: 2000,
          });

          this.$emit("created", { ...newDevice, tipo: "APARELHO" });

          this.hideModal();
        } else {
          const updateDevice = await this.$api.devices.userUpdate({
            id: this.form.id,
            nome: this.form.name,
            tipo: this.form.deviceType,
            localId: this.form.local,
            grupoId: this.form.grupoId,
            chave: this.form.key,
            accessPointCount: this.form.accessPointCount,
          });

          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t("message.successMessages.message.deviceEdited"),
            timeout: 2000,
          });

          EventBus.$emit("UPDATE_NODE", { ...updateDevice, tipo: "APARELHO" });

          this.hideModal();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async setDeviceTypes() {
      this.deviceTypes = await this.$api.devices.types();
    },
    async setDeviceTypesFormatted() {
      const tiposArray = Object.keys(this.devicesTypes);
      const array = tiposArray.map((tipo) => {
        if (tipo.includes("_")) return tipo.split("_")[0];
        return tipo;
      });
      const tiposArrayUnicos = Array.from(new Set(array));
      const arrayComObjetos = tiposArrayUnicos.map((tipo) => {
        return {
          brand: tipo,
          types: [],
        };
      });

      for (let item in this.devicesTypes) {
        const obj = arrayComObjetos.find(
          (tipo) => tipo.brand === item.split("_")[0]
        );
        obj.types.push(this.devicesTypes[item]);
      }
      this.formattedDeviceTypes = arrayComObjetos;
    },
    async edit(id) {
      this.closeExpansionPanel();

      const device = await this.$api.devices.get({
        id,
      });

      this.form = {
        id: device.id,
        name: device.nome,
        key: device.chave,
        local: device.localId,
        grupoId: device.grupoId,
        deviceType: device.tipo,
        accessPointCount: device.accessPointCount,
      };

      this.localOptions = [
        {
          id: device.localId,
          label: device.localNome,
        },
      ];

      await this.setDeviceTypesFormatted();

      this.selectedDevice = this.devicesTypes[this.type];
      this.returnCorrectLogo(true, this.selectedDevice);

      this.isEdit = true;
      document.addEventListener("mousedown", this.dragToFalse);
      document.addEventListener("mousemove", this.dragToTrue);
      document.addEventListener("mouseup", this.closeModal);
    },
    async continueModalCreation() {
      this.shouldContinueDeviceCreation = true;
      this.hideAditionalFeeModal();
      await this.save();
      if (this.doNotShowAditionalFeeModalAgain) {
        await this.$api.core.account.setAccountEstablishmentConfigShowPaymentInfo(
          { showPaymentInfo: !this.doNotShowAditionalFeeModalAgain }
        );
      }
    },
    hideAditionalFeeModal() {
      this.showingAditionalFeeModal = false;
    },
    setSelectedDevice(event, deviceName) {
      this.selectedDevice = deviceName;
      this.returnCorrectLogo(event, deviceName);
      this.form.deviceType = this.returnObjectKey(
        this.devicesTypes,
        this.selectedDevice
      );
      this.closeExpansionPanel();
      this.form.accessPointCount = 1;
    },
    returnObjectKey(obj, value) {
      for (const key in obj) {
        if (
          obj[key].toUpperCase() === value.toUpperCase() ||
          obj[key].toUpperCase().includes(value.toUpperCase())
        ) {
          return key;
        }
      }
      return null;
    },
    formatName(brandName, name) {
      if (name === "GRAND") return "Grandstream";
      if (name === "GrandStream (Cloud)") return "Cloud";
      if (brandName) {
        const brandNameInLowerCase = brandName.toLowerCase();
        const firstLetter = brandNameInLowerCase.charAt(0);
        const firstLetterCap = firstLetter.toUpperCase();
        const remainingLetters = brandNameInLowerCase.slice(1);
        const capitalizedWord = firstLetterCap + remainingLetters;
        const regex = new RegExp(capitalizedWord, "i");
        return regex.test(name)
          ? name.replace(regex, "").replace("(", "").replace(")", "")
          : capitalizedWord;
      }

      const nameInLowerCase = name.toLowerCase();
      const firstLetter = nameInLowerCase.charAt(0);
      const firstLetterCap = firstLetter.toUpperCase();
      const remainingLetters = nameInLowerCase.slice(1);
      const capitalizedWord = firstLetterCap + remainingLetters;
      return capitalizedWord;
    },
    returnCorrectLogo(event, brand) {
      if (brand.toLowerCase().includes("askey")) {
          if (event) this.logo = "askey";
          return "askey";
      }
      if (brand.toLowerCase().includes("zte")) {
          if (event) this.logo = "zte";
          return "zte";
      }
        if (brand.toLowerCase().includes("tplink")) {
            if (event) this.logo = "tplink";
            return "tplink";
        }
      if (brand.toLowerCase().includes("aruba")) {
        if (event) this.logo = "aruba";
        return "aruba";
      }
      if (brand.toLowerCase().includes("cambium")) {
        if (event) this.logo = "cambium";
        return "cambium";
      }
        if (brand.toLowerCase().includes("teltonika")) {
            if (event) this.logo = "teltonika";
            return "teltonika";
        }
        if (brand.toLowerCase().includes("hgu")) {
            if (event) this.logo = "hgu";
            return "hgu";
        }
      if (brand.toLowerCase().includes("cisco")) {
        if (event) this.logo = "cisco";
        return "cisco";
      }
      if (brand.toLowerCase().includes("edgecore")) {
        if (event) this.logo = "edgecore";
        return "edgecore";
      }
      if (brand.toLowerCase().includes("fortigate")) {
        if (event) this.logo = "fortigate";
        return "fortigate";
      }
      if (brand.toLowerCase().includes("grand")) {
        if (event) this.logo = "grandstream";
        return "grandstream";
      }
      if (brand.toLowerCase().includes("huawei")) {
        if (event) this.logo = "huawei";
        return "huawei";
      }
      if (brand.toLowerCase().includes("intelbras")) {
        if (event) this.logo = "intelbras";
        return "intelbras";
      }
      if (brand.toLowerCase().includes("mikrotik")) {
        if (event) this.logo = "mikrotik";
        return "mikrotik";
      }
      if (brand.toLowerCase().includes("omada")) {
        if (event) this.logo = "omada";
        return "omada";
      }
        if (brand.toLowerCase().includes("ruijie")) {
            if (event) this.logo = "ruijie";
            return "ruijie";
        }
      if (brand.toLowerCase().includes("ruckus")) {
        if (event) this.logo = "ruckus";
        return "ruckus";
      }
      if (brand.toLowerCase().includes("tanaza")) {
        if (event) this.logo = "tanaza";
        return "tanaza";
      }
      if (brand.toLowerCase().includes("unifi")) {
        if (event) this.logo = "unifi";
        return "unifi";
      }
      if (brand.toLowerCase().includes("aerohive")) {
        if (event) this.logo = "aerohive";
        return "aerohive";
      }
        if (brand.toLowerCase().includes("extreme")) {
            if (event) this.logo = "extreme";
            return "extreme";
        }

    },
    isSpecialLogo(brand) {
      if (brand === "INTELBRAS" || brand === "CISCO") return true;
      return false;
    },
    isSpecialCase(brand) {
      if (
        brand === "GRAND" ||
        brand === "EDGECORE" ||
        brand === "HUAWEI" ||
        brand === "OMADA" ||
        brand === "RUIJIE" ||
        brand === "AEROHIVE" ||
        brand === "EXTREME" ||
        brand === "ZTE" ||
        brand === "TPLINK" ||
        brand === "ASKEY"
      )
        return true;
      return false;
    },
    closeExpansionPanel() {
      this.isOpened.push(false);
      this.isOpened.shift();
    },
  },

  mounted() {
    this.shouldContinueDeviceCreation = false;
    if (this.node) this.reset();

    document.addEventListener("mousedown", this.dragToFalse);
    document.addEventListener("mousemove", this.dragToTrue);
    document.addEventListener("mouseup", this.closeModal);
  },

  beforeDestroy() {
    document.removeEventListener("mousedown", this.dragToFalse);
    document.removeEventListener("mousemove", this.dragToTrue);
    document.removeEventListener("mouseup", this.closeModal);
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.alinhar-items {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.v-dialog__content {
  border-radius: 5px;
}

.modal {
  border-radius: 5px;
}

.v-stepper {
  overflow: visible !important;
  overflow-y: visible !important;
}

.v-card {
  padding: 10px !important;
  text-align: center;

  .body {
    display: flex;
    gap: 50px;
    margin: 0 50px;

    .body-column {
      .body-column-section {
        display: flex;
        flex-direction: column;
        margin-bottom: 30px;

        .dropdown {
          margin: 0 auto;
        }

        .v-text-field {
          flex: 1;

          ::v-deep .v-text-field__details {
            display: none;
          }

          ::v-deep .v-input__slot {
            margin: 0;
          }
        }
      }

      .access-point-input {
        width: 60px;
        margin: 0 auto !important;

        ::v-deep input {
          text-align: center;
        }
      }
    }
  }

  .card-footer {
    margin-bottom: 20px;
  }

  .aditional-fee-text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .select-expansion-panel {
    box-shadow: none;
    border-radius: 0;
    border: 1px solid $grey-2;

    .select-expansion-panel-content {
      .select-expansion-panel-content-header {
        display: flex;
        gap: 20px;
        align-items: center;
        margin-right: 20px;

        .mdi {
          font-size: 26px;
        }

        .select-expansion-panel-content-header-title {
          margin-bottom: 0;
        }

        .select-expansion-panel-content-header-logo {
          width: 30px;
          height: 30px;
        }

        .special-select-expansion-panel-content-header-logo {
          width: 50px;
          height: 50px;
        }
      }

      .select-expansion-panel-content-body {
        padding: 10px 60px 10px 0;
        max-height: 300px;
        overflow-y: auto;
        .select-expansion-panel-content-body-list {
          list-style: none;

          .flex-container {
            display: flex;
            gap: 10px;
            .logo {
              width: 30px;
              height: 30px;
              margin-right: 10px;
            }

            .special-logo {
              width: 50px;
              height: 50px;
              margin-left: -10px;
              margin-top: -15px;
              margin-right: 0;
            }
          }

          .select-expansion-panel-content-body-list-item {
            cursor: pointer;
            padding-bottom: 15px;

            &:hover {
              font-weight: 700;
            }

            .sublist {
              padding-left: 0 !important;
            }
          }

          .subitem {
            padding-left: 24px;
            padding-bottom: 5px;
          }
        }
        .sublist {
          padding-left: 0;
        }
      }
    }
    .select-expansion-panel-content-special {
      ::v-deep .v-expansion-panel__header {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }
    }
  }
  .expansion-opened {
    min-width: 355px;
  }
}
</style>
